import { on } from 'delegated-events';

// #ga-list (view_item_list z ProductsUI) siedzi w #pjax-container - PJAX podmienia go razem z kaflami
let currentList = null;

function readList() {
    const el = document.getElementById('ga-list');
    if (!el) return null;

    try {
        const list = JSON.parse(el.textContent);
        return list && list.ecommerce && Array.isArray(list.ecommerce.items) ? list : null;
    } catch (err) {
        return null;
    }
}

function push(payload) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(payload);
    } catch (err) { /* tracker nie moze psuc sklepu */ }
}

function refreshList() {
    currentList = readList();
    if (currentList) push(currentList);
}

// pozycja kafla wsrod produktow siatki = pozycja w items (banery to a.listing-banner, nie [data-scope])
function clickedItem(link) {
    const tile = link.closest('[data-scope="addcart"]');
    const grid = tile && tile.parentElement;
    const cartButton = tile && tile.querySelector('[data-pid]');
    if (!grid || !cartButton) return null;

    const position = Array.prototype.indexOf.call(grid.querySelectorAll(':scope > [data-scope="addcart"]'), tile);
    const base = currentList.ecommerce.items[position];
    const pid = cartButton.getAttribute('data-pid');
    if (!base || String(base.item_id).split('_')[0] !== pid) return null;

    const item = Object.assign({}, base);
    const optionId = cartButton.getAttribute('data-optionid');

    // wariant przelaczony na kaflu (listing_variant): id i cena tego, co klient kliknal
    if (optionId && optionId !== '-1' && item.item_id !== `${pid}_${optionId}`) {
        item.item_id = `${pid}_${optionId}`;

        const price = tile.querySelector('[data-replace="price"]');
        const value = price ? Number(price.textContent.replace(/\s/g, '')) : NaN;
        if (Number.isFinite(value) && value > 0) item.price = value;
    }

    return item;
}

function onProductClick(e) {
    // srodkowy przycisk przychodzi jako auxclick; prawy (menu kontekstowe) to nie wybor produktu
    if (e.type === 'auxclick' && e.button !== 1) return;

    // zablokowany/wylaczony tracker: bez preventDefault i czekania na GTM - klik zawsze przechodzi
    try {
        if (!currentList) return;

        const item = clickedItem(this);
        if (!item) return;

        push({
            event: 'select_item',
            ecommerce: {
                item_list_id: currentList.ecommerce.item_list_id,
                item_list_name: currentList.ecommerce.item_list_name,
                items: [item]
            }
        });
    } catch (err) { /* jw. */ }
}

export default function () {
    refreshList();
    document.addEventListener('pjax:success', refreshList);

    on('click', '#pjax-container .products-list a.product-name', onProductClick);
    on('auxclick', '#pjax-container .products-list a.product-name', onProductClick);
}
